import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  MASTERPIECE_ARTWORK,
  gridDimsFromPieceCount,
} from "./masterpieceData";
import JigsawPuzzle from "./stage7/JigsawPuzzle";
import "./stage7/jigsaw-game.css";
import "./MasterpieceJigsaw.css";

/**
 * Interlocking jigsaw (swap + lock) inside an ornate frame.png border.
 * Uses the same JigsawPuzzle / FreeformJigsawSvg stack as try.jsx.
 */
export default function MasterpieceJigsaw({
  image = MASTERPIECE_ARTWORK.src,
  frame = MASTERPIECE_ARTWORK.frame,
  pieceCount = MASTERPIECE_ARTWORK.pieceCount,
  onComplete,
  onCorrectPieceCountChange,
  disabled = false,
}) {
  const { cols, rows } = useMemo(
    () => gridDimsFromPieceCount(pieceCount),
    [pieceCount]
  );

  const [boardSize, setBoardSize] = useState({ w: null, h: null });
  const [solved, setSolved] = useState(false);

  const handleBoardReady = useCallback((w, h) => {
    setBoardSize({ w, h });
  }, []);

  const handleComplete = useCallback(() => {
    setSolved(true);
    onComplete?.();
  }, [onComplete]);

  useEffect(() => {
    setSolved(false);
    setBoardSize({ w: null, h: null });
  }, [image, pieceCount]);

  return (
    <div className="masterpiece-jigsaw">
      <div
        className={`masterpiece-jigsaw__ornate${
          solved ? " masterpiece-jigsaw__ornate--solved" : ""
        }`}
        style={{ backgroundImage: `url(${frame})` }}
        aria-label="Masterpiece jigsaw puzzle"
      >
        <div
          className="masterpiece-jigsaw__board masterpiece-jigsaw__board--interlock"
          style={
            boardSize.w && boardSize.h
              ? { aspectRatio: `${boardSize.w} / ${boardSize.h}` }
              : undefined
          }
        >
          <JigsawPuzzle
            key={`${rows}x${cols}-${image}`}
            imageUrl={image}
            rows={rows}
            cols={cols}
            pieceType="classic"
            puzzleType="interlock"
            targetBoardWidth={800}
            disabled={disabled}
            onBoardReady={handleBoardReady}
            onComplete={handleComplete}
            onCorrectPieceCountChange={onCorrectPieceCountChange}
          />
        </div>
      </div>
    </div>
  );
}
